import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=58bc747a"
import script from "./NewsFilter.js?vue&type=script&lang=js&external"
export * from "./NewsFilter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports